var map = {
	"./custom.png": 63,
	"./fasting.png": 61,
	"./gain_weight.png": 58,
	"./healthy.png": 57,
	"./keto.png": 55,
	"./medical.png": 60,
	"./nutritient.png": 62,
	"./vegan.png": 56,
	"./wedding.png": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 272;